import { shallowEqual, useSelector } from 'react-redux';

const useUserPreference = (key) => {
  const preferenceValue = useSelector((state) => state?.auth?.getUserPreference?.data?.[key], shallowEqual);
  return preferenceValue ? preferenceValue : undefined;
};

export default useUserPreference;

//  Use this hook like following way

// const userDateFormat = useUserPreference(
//     USER_PREFERENCES.DEFAULT_DATE_FORMAT
//   );
